import Marionette from "../../../shared/marionette-mustache";
import { FullTextRevisionsModel } from "../../../desktop/models/full-text-revisions";
import { AuthorizationModel } from "../../../authentication/models/authorization-model";
import { AppSettings } from "../../../app-settings";

import { backboneViewProperties } from "../../../decorators/backbone-properties";

import { Container } from "aurelia-dependency-injection";
import { AppEvents} from "../../../app-events";
import { ContainerHelper } from "../../../shared/helpers/container-helper";

const template = require<string>("../../../desktop/views/partials/legislation-latest-revision.html");
@backboneViewProperties({
    tagName: "div",
    template,
    className: "full-text-revisions"
})
export class FullTextRevisionsView extends Marionette.ItemView<FullTextRevisionsModel> {

    private contentFrame: HTMLIFrameElement;
    private peekFrame: HTMLIFrameElement;
    private peekPopover: JQuery;

    constructor(options?: Backbone.ViewOptions<FullTextRevisionsModel>) {
        super(options);
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click .show-changes"] = (e) => this.showChangesClick(e);
        return events;
    }

    public async onShow() {
        const link = await this.getLink();
        if (link) {
            const url = `${AppSettings.DocumentApiUrlPrefix}legislationrevisions?reference=${this.model.Reference}`;
            this.setupIFrameMessageListener(link);
            this.addContentFrame(url);
        }
    }

    private showChangesClick(e: JQueryMouseEventObject) {
        this.$(".external-gov-link").trigger("click");
    }

    private addContentFrame(url: string) {
        this.contentFrame = document.createElement("iframe");
        this.contentFrame.style.display = "none";
        this.contentFrame.onload = () => {
            this.contentFrame.style.display = "block";
            this.$(".legislation-gov-loading").hide();
            this.setupFocusListener();
        };
        this.contentFrame.src = url;
        this.$(".revision-content-container").get(0).appendChild(this.contentFrame);
    }

    private setupIFrameMessageListener(url: string) {
        url = url.replace("contents", "");
        const eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        const eventer = window[eventMethod];
        const messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
        eventer(messageEvent, (e) => {
            if (!e.data || !e.data.toString().startsWith("docReady")) {
                return;
            }
            if (e.data.replace("docReady:", "").replace("data.html", "")) {
                this.$el.parents(".fulltext-latest-revision").find(".revisions-read-mode").removeAttr("disabled");
            }
        }, false);
    }

    private async getLink(): Promise<string> {
        const result = await this.model.getLink().then((url) => {
            if (url) {
                const link = `<span>This is the latest revision available from <a href="${url}" target="_blank">legislation.gov.uk</a></span>`;
                const target = this.$el.parents(".fulltext-latest-revision").find(".external-gov-link");
                target.html(link);
            }
            return url; // Resolves the .then() callback and stores this value into result variable
        }).catch((errorMessage) => {
            this.$(".revision-content-container").addClass("error").append(errorMessage);
            this.$(".legislation-gov-loading").hide();
            return null;
        });
        return result;
    }

    private setupFocusListener() {
        const appEvents = ContainerHelper.Events;
        this.listenTo(appEvents, AppEvents.ViewLegislationRevision, this.redrawIframe);
    }

    private redrawIframe(id) {
        if (this.model.Id === id) {
            const frame = this.contentFrame;
            if (frame) {
                frame.contentWindow.postMessage(`redraw:please`, "*");
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/partials/full-text-revisions.ts